<template>
  <v-card flat>
    <v-card-text class="install-panel">
      <v-flex>

        <v-stepper v-model="stepIndex">
          <v-stepper-header style="width: 90%;margin-left: auto;margin-right: auto;">
            <template v-for="(step, index) in steps">
            <v-stepper-step :key="index" :step="step.index">{{step.title}}</v-stepper-step>
            <v-divider v-if="step.next" :key="index + 'd'" ></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>

            <v-stepper-content v-for="(step, index) in steps" :key="index" :step="step.index">
              <v-layout v-if="step.title === 'Checklist'" wrap style="text-align: center;">
                <v-flex xs12>
                  <span class="font-weight-bold" style="font-size:28px;">Preparing your environment checklist</span>
                  <br/>
                  <br/>
                  <span class="body-1">
                  Before you begin setting up, please review the checklist to ensure you've already prepared your environment for the installation.
                  </span>
                  <br/>
                  <br/>
                  <br/>
                </v-flex>
                <v-flex xs6 style="text-align: left;">
                <v-flex ma-2>
                  <v-icon size="14">fal fa-check</v-icon>&nbsp;&nbsp;<span class="body-2">1. Prepare a WXP Collaboration Data Collector server instance</span>
                  <v-btn icon @click="showChecklist1 = !showChecklist1">
                    <v-icon size="14">{{ showChecklist1 ? 'fal fa-chevron-down' : 'fal fa-chevron-right' }}</v-icon>
                  </v-btn>
                  <div v-if="showChecklist1">
                  <div>A server must be provisioned on which the WXP Collaboration Data Collector will be installed and configured. The Data Collector is used to communicate with your video infrastructure in your internal, and in some cases, external environment. The server can be either a virtual or physical appliance. The server will need network access to your video infrastructure and will always be running.</div>
                  </div>
                </v-flex>
                <v-flex ma-2>
                  <v-icon size="14">fal fa-check</v-icon>&nbsp;&nbsp;<span class="body-2">2. Test the connection to the WXP Collaboration Cloud</span>
                  <v-btn icon @click="showChecklist2 = !showChecklist2">
                    <v-icon size="14">{{ showChecklist2 ? 'fal fa-chevron-down' : 'fal fa-chevron-right' }}</v-icon>
                  </v-btn>
                  <div v-if="showChecklist2">
                  <div>It is important to test the connection to WXP Collaboration�s Cloud on the VM or server provisioned. To test the connection to the WXP Collaboration Cloud, the Administrator must ensure https connectivity to WXP Collaboration Cloud Servers.</div>
                  <div class="mt-2"><a :href="brandingService.getSupportUrl('urlRequirements')" target="_blank">More details</a> on URL requirements for the WXP Collaboration product</div>
                  <div class="mt-5"><h2>Please perform the following tests from Remote Desktop (RDP) on the WXP Collaboration Data Collector Server:</h2></div>
                  <div class="mt-4">
                    <ol>
                      <li>Navigate to <a href="https://login.vyopta.com/auth/">https://login.vyopta.com/auth/</a> and confirm that you see the WXP Collaboration logo</li>
                      <li>Navigate to <a href="https://api.vyopta.com/auth/">https://api.vyopta.com/auth/</a> and confirm that you see the WXP Collaboration logo</li>
                      <li>Navigate to <a href="https://galaxy-admin-mq.vyopta.com">https://galaxy-admin-mq.vyopta.com/</a> and confirm that you see an API response - HTTP 400 Error with No clientID header specified.</li>
                    </ol>
                  </div>
                  </div>
                </v-flex>
                <v-flex ma-2>
                  <v-icon size="14">fal fa-check</v-icon>&nbsp;&nbsp;<span class="body-2">3. Reviewed the recommended specs</span>
                  <v-btn icon @click="showChecklist3 = !showChecklist3">
                    <v-icon size="14">{{ showChecklist3 ? 'fal fa-chevron-down' : 'fal fa-chevron-right' }}</v-icon>
                  </v-btn>
                  <div v-if="showChecklist3">
                  <table class="mt-4">
                    <tr>
                      <td><strong>CPU</strong></td>
                      <td>Dual CPUs (2.4GHz or higher)</td>
                    </tr>
                    <tr>
                      <td><strong>Memory</strong></td>
                      <td>8GB RAM</td>
                    </tr>
                    <tr>
                      <td><strong>Storage</strong></td>
                      <td>80GB disk space (OS and Data)</td>
                    </tr>
                    <tr>
                      <td><strong>Network</strong></td>
                      <td>1 Gbps NIC</td>
                    </tr>
                    <tr>
                      <td><strong>Server Operating System</strong></td>
                      <td>Windows Server (2012 R2, 2016, 2019) CentOS 7/6+ or RHEL 7/6+</td>
                    </tr>
                    <tr>
                      <td><strong>Java</strong></td>
                      <td>Java 11 (bundled with installer)</td>
                    </tr>
                  </table>
                  </div>
                </v-flex>
                </v-flex>
                <v-flex xs12>
                  <div class="mt-5">
                    <v-checkbox class="checkbox" v-model="collabConnection" label="I have prepared my environment"></v-checkbox>
                    <button class="btn btn-primary" :disabled="!collabConnection" @click="goNext(step); collabConnection=false;">Continue</button>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout v-if="step.title === 'License'" wrap style="text-align: center;">
               <v-flex xs12 style="text-align:center; margin-bottom:20px;">
                  <span class="font-weight-bold" style="font-size:28px;">License</span>
                </v-flex>
                <v-flex xs6 style="text-align: left;">
                 <v-flex min-height="200px">
                <h2>Accept HP and OpenJDK 11 (GPLv2) License</h2>
                (Please note that WXP Collaboration Collector uses OpenJDK for Java 11 runtime platform, which is
                covered under <a target="_blank" href="http://openjdk.java.net/legal/gplv2+ce.html">
                GPLv2 license agreement and related licenses</a>)
                <p></p>
                You must accept the
                  <v-tooltip bottom>
                      <template v-slot:activator="{on}">
                        <a target="_blank" href="https://support.hp.com/us-en/document/ish_4416646-4390016-16">License Agreement</a>
                      </template>
                      Opens in new window
                  </v-tooltip> to continue.
                  <v-checkbox v-model="eulaAccepted">
                  <div slot="label">
                      I Accept the OpenJDK and WXP Collaboration License Agreements
                  </div>
                  </v-checkbox>
                  <button class="btn btn-default" @click="goPrev(step)">Back</button>
                  <button class="btn btn-primary" :disabled="!eulaAccepted" @click="goNext(step); eulaAccepted=false;">Continue</button>
                  </v-flex>
              </v-flex>
              </v-layout>
              <v-layout v-if="step.title === 'Service Account'" wrap style="text-align: center; justify-content: center;">
               <v-flex xs12 style="text-align:center; margin-bottom:10px;">
                  <span class="font-weight-bold" style="font-size:28px;">Service Account</span>
                </v-flex>
                <v-flex xs8 style="text-align: left;">
                <v-flex xs12>
                  <h2>The data collector requires to login to the WXP Collaboration Cloud with a service account.</h2>
                  <v-checkbox v-model="existingUser" v-if="allUsers && allUsers.length" label="Use an existing service account">
                  </v-checkbox>
                  <div v-if="!existingUser">
                      <create-user @success="(login) => userSuccess(login, step)"></create-user>
                  </div>
                </v-flex>
                <button
                  class="btn btn-default"
                  @click="goPrev(step)"
                >
                  Back
                </button>
                <button
                  class="btn btn-primary"
                  @click="goNext(step)"
                  :disabled="!continueUser"
                >
                  Continue
                </button>
                </v-flex>
              </v-layout>
              <v-layout v-if="step.title === 'Configuration'" wrap style="text-align: center; justify-content: center;">
               <v-flex xs12 style="text-align:center; margin-bottom:10px;">
                  <span class="font-weight-bold" style="font-size:28px;">Configuration</span>
                </v-flex>
                <v-flex xs8 style="text-align: left;">
                 <v-flex xs12>
                  <h2>The data collector requires a configuration file to be present alongside the collector.</h2>
                  <v-checkbox v-model="existingConfig" label="Use an existing vyoptacollector.xml configuration file">
                  </v-checkbox>
                  <div v-if="!existingConfig">
                      <config-file :key="stepIndex" :defaultLogin="serviceAccount" @success="configSuccess(step)"></config-file>
                  </div>
                </v-flex>
                <button
                  class="btn btn-default"
                  @click="goPrev(step)"
                >
                  Back
                </button>
                <button
                  class="btn btn-primary"
                  @click="goNext(step)"
                  :disabled="!continueConfig"
                >
                  Continue
                </button>
                </v-flex>
              </v-layout>

              <!--
              <v-layout v-if="step.title === 'Collector Maintenance'" wrap style="text-align: center;">
               <v-flex xs12 style="text-align:center; margin-bottom:10px;">
                  <span class="font-weight-bold" style="font-size:28px;">Collector Maintenance</span>
                </v-flex>
                  <v-flex xs8 style="text-align: left;">

                 WXP Collaboration can perform collector maintenance and upgrades without requiring your intervention. 
                 This is an optional feature, but is recommended  – Please see 
                 <a :href="brandingService.getSupportUrl('upgradeCollector')" target="_blank">helpdesk article</a> 
                 for more information and make your choice below:

                  <v-checkbox v-model="autoUpdate" label="I authorize WXP Collaboration to upgrade collectors">                
                  </v-checkbox>

                  <v-form ref="form" lazy-validation @submit.prevent>

                  <v-layout wrap v-if="autoUpdate" mb-12>
                    <v-flex xs12 mb-4>
                    You can choose a maintenance window during which the any collector upgrades are applied - 
                    the times for this window will be the local time for the system running the collector service.
                    </v-flex>

                  <v-flex xs6>
                  Days:
                      <v-btn-toggle v-model="upgradeDays" multiple>
                        <v-btn text>
                          S
                        </v-btn>
                        <v-btn text>
                          M
                        </v-btn>
                        <v-btn text>
                          T
                        </v-btn>
                        <v-btn text>
                          W
                        </v-btn>
                        <v-btn text>
                          T
                        </v-btn>
                        <v-btn text>
                          F
                        </v-btn>
                        <v-btn text>
                          S
                        </v-btn>
                      </v-btn-toggle>
                  </v-flex>
                  
                  <v-flex xs1 v-if="autoUpdate"></v-flex>
                  <v-flex xs1 v-if="autoUpdate">Times:</v-flex>
                  <v-flex xs1 v-if="autoUpdate">
                       <v-text-field label="from" v-model="upgradeFrom" :rules="[checkTimes]"></v-text-field>
                 </v-flex>
                  <v-flex xs1 v-if="autoUpdate"></v-flex>
                  <v-flex xs1 v-if="autoUpdate">
                       <v-text-field v-model="upgradeTo" label="to" :rules="[checkTimes]"></v-text-field>
                 </v-flex>
                  </v-layout>
                  </v-form>

              <button
                class="btn btn-default"
                @click="goPrev(step)"
              >
                Back
              </button>
              <button
                class="btn btn-primary"
                @click="saveAutoUpdate(step)"
              >
                Save and Continue
              </button>
                  </v-flex>
              </v-layout> -->

              <v-layout v-if="step.title === 'Download'" wrap style="text-align: center;">
               <v-flex xs12 style="text-align:center; margin-bottom:10px;">
                  <span class="font-weight-bold" style="font-size:28px;">Download</span>
                </v-flex>
                <v-flex xs12 mb-4 style="text-align: center;">
                    <span style="font-size: 14px;font-weight: bold;">Download the WXP Collaboration data collector (stable version)</span>
                </v-flex>
                  <v-flex xs8 style="text-align: left;">
                    <v-flex xs12>
                      <table style="padding: 10px;">
                        <thead>
                          <th><v-icon>fa-brands fa-windows</v-icon>&nbsp;Windows</th>
                          <th></th>
                          <th><v-icon>fa-brands fa-linux</v-icon>&nbsp;Linux</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>&nbsp;{{removeBuild(collectorStableVersion)}}</td>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td>&nbsp;{{removeBuild(collectorStableVersion)}}</td>
                          </tr>
                          <tr v-if="collectorStableVersion.includes('.0.')">
                            <td><a :href="'/download/api/v1/collector/GA/'+collectorStableVersion+'/exe'">vyoptacollector.exe</a></td>
                            <td>&nbsp;</td>
                            <td><a :href="'/download/api/v1/collector/GA/'+collectorStableVersion+'/sh'">vyoptacollector.sh</a></td>
                          </tr>
                          <tr v-else>
                            <td><a :href="'/download/api/v1/collector/RC/'+collectorStableVersion+'/exe'">vyoptacollector.exe</a></td>
                            <td>&nbsp;</td>
                            <td><a :href="'/download/api/v1/collector/RC/'+collectorStableVersion+'/sh'">vyoptacollector.sh</a></td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                          <tr>
                            <td>Installation</td>
                            <td>&nbsp;</td>
                            <td>Installation</td>
                          </tr>
                          <tr>
                            <td>Place alongside vyoptacollector.xml and run:<br>
                              <code>vyoptacollector.exe -install <br> [-username &lt;username&gt; -password &lt;password&gt;]</code></td>
                            <td>&nbsp;</td>
                            <td>Place alongside vyoptacollector.xml and run:<br><code>chmod 755 vyoptacollector.sh<br>
                              sudo ./vyoptacollector.sh -install <br> [-username &lt;username&gt; -password &lt;password&gt;]</code></td>
                          </tr>
                        </tbody>
                      </table>
                    </v-flex>
                    <v-flex xs12 mb-10 mt-5>
                      <v-layout wrap>
                        <span class="subheading"><b>Other versions:</b></span>
                        <v-icon v-if="showOtherVersions" @click="showOtherVersions = !showOtherVersions">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showOtherVersions" @click="showOtherVersions = !showOtherVersions">fal fa-chevron-down</v-icon>
                    </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="showOtherVersions" style="margin-top: -30px; margin-bottom: 16px;">
                      <table style="width:100%;">
                        <thead>
                          <th></th>
                          <th></th>
                          <th></th>
                        </thead>
                        <tbody>
                          <tr v-for="(v,i) in collectorNewVersions" :key="v" style="line-height: 30px;">
                            <td>{{removeBuild(v)}}</td>
                            <td v-if="v.includes('.0.')"><a :href="'/download/api/v1/collector/GA/'+v+'/exe'">vyoptacollector.exe</a></td>
                            <td v-else><a :href="'/download/api/v1/collector/RC/'+v+'/exe'">vyoptacollector.exe</a></td>
                            <td v-if="v.includes('.0.')"><a :href="'/download/api/v1/collector/GA/'+v+'/sh'">vyoptacollector.sh</a></td>
                            <td v-else><a :href="'/download/api/v1/collector/RC/'+v+'/sh'">vyoptacollector.sh</a></td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                          <tr>
                            <td><v-btn text @click="oldVersions = true" class="btn btn-default">Archived Versions</v-btn></td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-flex>
              
                <v-dialog v-model="oldVersions" max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Archived Versions</span>
                    </v-card-title>

                    <v-card-text>
                    <v-flex xs12>
                      <table style="width:100%;">
                        <thead>
                          <th></th>
                          <th></th>
                          <th></th>
                        </thead>
                        <tbody>
                          <tr v-for="(v,i) in collectorOldVersions" :key="v" style="line-height: 30px;">
                            <td>{{removeBuild(v)}}</td>
                            <td v-if="v.includes('.0.')"><a :href="'/download/api/v1/collector/GA/'+v+'/exe'">vyoptacollector.exe</a></td>
                            <td v-else><a :href="'/download/api/v1/collector/RC/'+v+'/exe'">vyoptacollector.exe</a></td>
                            <td v-if="v.includes('.0.')"><a :href="'/download/api/v1/collector/GA/'+v+'/sh'">vyoptacollector.sh</a></td>
                            <td v-else><a :href="'/download/api/v1/collector/RC/'+v+'/sh'">vyoptacollector.sh</a></td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-flex>
                    </v-card-text>
                    </v-card>

                    </v-dialog>
              <button
                class="btn btn-default"
                @click="goPrev(step)"
              >
                Back
              </button>
              <button
                class="btn btn-primary"
                @click="goNext(step)"
              >
                Done
              </button>
                  </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import BrandingService from '../../../../services/branding.service';
import ConfigFile from './ConfigFile.vue'
import CreateUser from '../Users/CreateUser.vue'
import _ from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'
    export default {
        props: {
          mode: String
        },
        components: {
            'config-file': ConfigFile,
            'create-user': CreateUser
        },
        data: () => ({
          brandingService: BrandingService,
          showChecklist1: false,
          showChecklist2: false,
          showChecklist3: false,
            stepIndex: 1,
            eulaAccepted: false,
            collabConnection: false,
            downloading0: false,
            downloading1: false,
            downloading2: false,
            downloading3: false,
            downloadingAny: false,
            existingUser: false,
            existingConfig: false,
            continueUser: false,
            continueConfig: false,
            serviceAccount: null,
            autoUpdate: false,
            upgradeDays: [0, 1, 2, 3, 4, 5, 6],
            upgradeFrom: '00:00',
            upgradeTo: '23:59',
            installSteps: [
              {index: '1', title: 'Checklist', next: '2', prev: ''},
              {index: '2', title: 'License', next: '3', prev: '1'},
              {index: '3', title: 'Service Account', next: '4', prev: '2'},
              {index: '4', title: 'Configuration', next: '5', prev: '3'},
              // {index: '5', title: 'Collector Maintenance', next: '6', prev: '4'},
              {index: '5', title: 'Download', next: '', prev: '4'}
            ],
            upgradeSteps: [
              {index: '1', title: 'Configuration', next: '2', prev: ''},
              // {index: '2', title: 'Collector Maintenance', next: '3', prev: '1'},
              {index: '2', title: 'Download', next: '', prev: '1'}
            ],
            rules: {
              required: (value) => !!value || "Required."
            },
            showOtherVersions: false,
            oldVersions: false
        }),
        computed: {
            ...mapGetters('user', {
                allUsers: 'activeUsers',
                orgContext: 'getOrgContext'
            })   ,
            ...mapGetters('collectors', {
              collectorStableVersion: 'collectorStableVersion',
              collectorOldVersions: 'collectorOldVersions',
              collectorNewVersions: 'collectorNewVersions'
            }),
            steps: {
              get() {
                if (this.mode === 'install') {
                  return this.installSteps
                } else {
                  return this.upgradeSteps
                }
              }
            }
        },
        async created() {
            await this.$store.dispatch('user/getAllUsers')
            this.autoUpdateSchedule = ''
            const autoUpdateSchedule = await this.$store.dispatch('collectors/getAutoUpgrade')
            if (autoUpdateSchedule 
                && (autoUpdateSchedule !== 'false') 
                && (autoUpdateSchedule.includes('|'))) {
              this.autoUpdate = true
              const tokens = autoUpdateSchedule.split('|')
              this.upgradeDays = _.map(tokens[0].split(','), x => +x)
              this.upgradeFrom = tokens[1]
              this.upgradeTo = tokens[2]
            } else if (autoUpdateSchedule === '') {
              // default to true
              this.autoUpdate = true
            } 
            else {
              this.autoUpdate = false
            }
        },
        watch: {
            eulaAccepted: function(val) {
              if (val) {
                var objActivity = {
                    action: 'eula-acceptance',
                    appId: 'cpm-admin',
                    view: this.$route.name,
                    tab: '',
                    url: window.location.href,
                    source: this.$route.path,
                    data: 'Eula Accepted'
                }
                this.$store.dispatch('status/logActivity',objActivity)
              }
            },
            existingUser: function(val) {
              this.continueUser = val
            },
            existingConfig: function(val) {
              this.continueConfig = val
            },
            orgContext: async function(val) {
              if (!val) {
                  return
              }

              await this.$store.dispatch('user/getAllUsers')
              // if (this.allUsers && this.allUsers.length) {
              //     this.existingUser = true
              // }
            },
            upgradeFrom: function(val) {
                this.$refs.form[0].validate()
            },
            upgradeTo: function(val) {
                this.$refs.form[0].validate()
            }
        },
        methods: {
            downloading(index) {
                return index === 0 ? this.downloading0 : index === 2 ? this.downloading1 : index === 3 ? this.downloading2 : this.downloading3
            },
            setDownloading(index, val) {
                if (index === 0) {
                    this.downloading0 = val
                } else if (index === 1) {
                    this.downloading1 = val
                } else if (index === 2) {
                    this.downloading2 = val
                } else {
                    this.downloading3 = val
                }
                this.downloadingAny = this.downloading0 || this.downloading1 || this.downloading2 || this.downloading3
            },
            configSuccess (step) {
              this.continueConfig = true
              this.goNext(step)
            },
            userSuccess (login, step) {
              this.serviceAccount = login
              this.continueUser = true
              this.goNext(step)
            },
            goPrev(step) {
              if (step.prev) {
                this.stepIndex = step.prev
              } else {
                this.$router.replace({ name: "welcomepage" })
              }
            },
            goNext(step) {
              if (step.next) {
                this.stepIndex = step.next
              } else {
                this.$router.replace({ name: "welcomepage" })
              }
            },
            checkTimes(timeval) {
              if (!/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(timeval)) { return 'Invalid format 00:00' }
              if (this.upgradeFrom >= this.upgradeTo) {
                return 'From must be prior to To'
              }
              return true
            },
            // async saveAutoUpdate(step) {
            //   if (this.autoUpdate && this.upgradeDays && this.upgradeDays.length && this.upgradeFrom && this.upgradeTo) {
            //     const result = _.join(this.upgradeDays) + '|' + this.upgradeFrom + '|' + this.upgradeTo
            //     await this.$store.dispatch('collectors/saveAutoUpgrade', result)
            //   } else {
            //     await this.$store.dispatch('collectors/saveAutoUpgrade', 'false')
            //   }
            //   this.goNext(step)
            // },
            removeBuild(str) {
              let p = str.lastIndexOf('.')
              return str.substring(0, p)
            }
        }
    }
</script>
<style scoped>
  .v-btn-toggle > .v-btn.v-btn--active {
    background-color:  var(--default-color);
    color: white;
  }
  .install-panel {
    padding: 0;
  }
  .install-panel, .install-panel h2 {
    font-size: 14px;
  }
  .checkbox {
    max-width: 150px;
    display: inline-block;
    vertical-align: middle;
  }
  .button {
    margin-bottom: 12px;
  }
</style>
<style>
  /* Override vuetify styles */
  .checkbox label.v-label {
    font-size: 10px;
    line-height: 12px;
  }
  .install-panel .v-stepper,
  .install-panel .v-stepper__header {
    box-shadow: none;
  }
</style>
